import React from "react";
import { CustomerDetails } from "features/Customers";
import { KpsPageContent } from "components/containers";
import { useParams, useLocation } from "react-router-dom";
import { CustomerRoutes } from "constants/routes";
import { Breadcrumb } from "@redriver/cinnamon";
import queryString from "query-string";

const CustomerDetailsPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const query = queryString.parse(location.search);

  return (
    <KpsPageContent
      renderHeader={() => (
        <Breadcrumb>
          <Breadcrumb.Item link={CustomerRoutes.Customers} icon="chevron left">
            Return to Customers
          </Breadcrumb.Item>
        </Breadcrumb>
      )}
    >
      <CustomerDetails customerId={id} tab={query.tab} />
    </KpsPageContent>
  );
};

export default CustomerDetailsPage;
